// メッセージMap
export const MessageMap = {
    "training_report": "実習報告",
    "answer_result": "インターンシップに参加して自分の役に立ったことはなんですか"
};
